import JSRouter from "adminPage/JSRouter";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import Ajax from "base/Ajax";
import Flatpickr from "flatpickr";
import ConfirmModal from "modal/ConfirmModal";

JSRouter.register('sk8House', new RegExp('^/([0-9a-f]+)/?'), (url_args) => {

    let $form = $('.js-event-form');
    let $ticketsForm = $('.js-add-bookings-form');

    FormValidator.attach($form).on("submit", ($form) => {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("sk8House", "events/" + (url_args[0] === "add" ? "" : url_args[0]), $form.serializeJSON()).then((event) => {
            if (url_args[0] === "add") {
                Message.schedule(new Message('Event added successfully', '', Message.SUCCESS));

                window.location.href = '/admin/sk8House/' + event.id;
            } else {
                new Message('Event updated successfully', '', Message.SUCCESS);

                $btn.removeClass("admin-btn--loading");
            }
        }).catch((e) => {
            $btn.removeClass("admin-btn--loading");
            new Message(e.message, "Couldn't update this event");
        })
    });

    FormValidator.attach($ticketsForm).on("submit", ($form) => {
        let $btn = $ticketsForm.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post('sk8House', 'events/' + url_args[0] + '/add-external-bookings', $ticketsForm.serializeJSON()).then((event) => {
            new Message('Event updated successfully', '', Message.SUCCESS);
            $('.js-spaces-taken').val(event.spacesTaken);
            $btn.removeClass("admin-btn--loading");
        }).catch((e) => {
            $btn.removeClass("admin-btn--loading");
            new Message(e.message, "Couldn't update this event");
        });
    });

    $form.on("click", ".js-delete-event", function () {
        ConfirmModal.confirm('Are you sure want to remove this event?', undefined, {showLoading: true}).then((done) => {
            Ajax.delete("sk8House", "events/" + url_args[0]).then(() => {
                Message.schedule(new Message('Event deleted successfully', '', Message.SUCCESS));

                window.location.href = window.CONFIG.urls.admin + 'sk8House';
            }).catch((e) => {
                new Message(e.message, "Couldn't delete this event");
                done();
            })
        });

        return false;
    });

    new Flatpickr($(".js-date")[0], {
        static: true,
        minDate: new Date,
        enableTime: false,
        altInput: false,
        dateFormat: 'Y-m-d',
        animate: false
    });

});